import { Fragment, NodeType } from '@tiptap/pm/model';
import { EMPTY_NODE_SIZE } from './isTiptapEditorEmpty';

/**
 * Determines if a node's content contains only a single empty paragraph.
 */
export const isNodeContentOnlyEmptyParagraph = (content: Fragment, paragraphType: NodeType): boolean => {
    if (!content) return true;
    if (content.childCount === 0) return true;
    if (content.childCount !== 1) return false;

    const firstChild = content.firstChild;
    if (!firstChild) return true;

    // If the first child is not a paragraph, it's not an empty paragraph
    if (firstChild.type !== paragraphType) return false;

    // If the paragraph has text content, it's not empty
    if (firstChild.textContent !== '') return false;

    // Empty nodes have a size of 2 because of the entering/leaving positions
    return firstChild.nodeSize === EMPTY_NODE_SIZE;
};
